import React, { useState } from "react";
// Use Forms
import { useForm } from "react-hook-form";
// React Bootstrap
import { Form, Button, Col, Accordion, Card } from "react-bootstrap";

const FormAmbitos = ({ defaultValues, objAmbitos, submissionHandler }) => {
  const [validated] = useState(false);
  const { register, handleSubmit } = useForm({
    defaultValues: defaultValues,
  });

  // Función que genera el objeto que necesita la petición para añadir o eliminar ámbitos
  const getObjAmbitos = (misAmbitos) => {
    const obj = {
      workScopeAdd: [],
      workScopeRemove: [],
    };
    Object.keys(objAmbitos).forEach((tipo) => {
      if (misAmbitos[tipo]) {
        obj.workScopeAdd.push(tipo);
      } else {
        obj.workScopeRemove.push(tipo);
      }
    });
    return obj;
  };

  // On submit del formulario
  const onSubmit = (data) => {
    data.objAmbitos = getObjAmbitos(data);
    submissionHandler(data);
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)} className="m-3">
      <Form.Row>
        <small className="mb-3">
          Los campos con un <b>*</b> deben de ser rellenados.
        </small>
      </Form.Row>

      {Object.keys(objAmbitos).length && (
        <Accordion defaultActiveKey="0" className="mb-2">
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="0">
              Ámbitos
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                {Object.keys(objAmbitos).map((tipo) => (
                  <Form.Group as={Col} xs={12} md controlId={tipo + "-Ambitos"}>
                    <Form.Check custom label={objAmbitos[tipo]} name={tipo} key={tipo} defaultChecked={defaultValues.length && defaultValues.find((f) => f.type === tipo)} {...register(tipo, {})} />
                  </Form.Group>
                ))}
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      )}
      <Form.Group>
        <Button type="submit" variant="outline-primary" className="btn btn-block mt-5">
          Guardar
        </Button>
      </Form.Group>
    </Form>
  );
};

export default FormAmbitos;
